/* Independent of the theme's obfuscated MenuDrawer implementation. */
if (!customElements.get('milanis-drawer')) {
  customElements.define('milanis-drawer', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.dialog = this.querySelector('dialog');
      this.toggle = this.querySelector('[data-mv-open]');
      this.header = this.closest('.section-header');
      this.sticky = this.closest('sticky-header');
      if (!this.dialog || !this.toggle) return;
      this.toggle.addEventListener('click', () => this.open(), options);
      this.dialog.querySelector('[data-mv-close]').addEventListener('click', () => this.close(), options);
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('click', event => {
        if (event.target === this.dialog) {
          const rect = this.dialog.getBoundingClientRect();
          if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.close();
          return;
        }
        const button = event.target.closest('[data-mv-expand]');
        if (button) {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          if (!panel || !this.dialog.contains(panel)) return;
          const expanded = button.getAttribute('aria-expanded') === 'true';
          button.setAttribute('aria-expanded', String(!expanded));
          panel.hidden = expanded;
          return;
        }
        const link = event.target.closest('a');
        if (link && link.getAttribute('href') === '#') {
          const expand = link.parentElement.querySelector('[data-mv-expand]');
          if (expand) { event.preventDefault(); expand.click(); }
        } else if (link) {
          this.close();
        }
      }, options);
      this.desktop = window.matchMedia('(min-width: 1100px)');
      this.desktop.addEventListener('change', () => { if (this.desktop.matches) this.close(); }, options);
    }
    open() {
      if (this.dialog.open) return;
      this.dialog.showModal();
      this.savedOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      this.locked = true;
      this.toggle.setAttribute('aria-expanded', 'true');
      this.header?.classList.add('menu-open');
      if (this.sticky) {
        this.savedPreventHide = this.sticky.preventHide;
        this.sticky.preventHide = true;
      }
      this.dialog.querySelector('[data-mv-close]').focus();
    }
    close() { if (this.dialog?.open) this.dialog.close(); }
    restore() {
      if (!this.locked) return;
      document.body.style.overflow = this.savedOverflow;
      this.locked = false;
      this.toggle.setAttribute('aria-expanded', 'false');
      this.header?.classList.remove('menu-open');
      if (this.sticky) this.sticky.preventHide = this.savedPreventHide;
      if (this.isConnected && !this.desktop.matches) this.toggle.focus();
    }
    disconnectedCallback() {
      this.close();
      this.restore();
      this.controller?.abort();
      this.controller = null;
    }
  });
}
